/**
 * Progress Status Constants
 * These values MUST match the backend ProgressStatus enum
 */

export const PROGRESS_STATUS = {
  TODO: 'todo',
  DOING: 'doing',
  DONE: 'done'
}

/**
 * Get statuses that require action
 * @returns {Array<string>}
 */
export const getStatusesWhichNeedAction = () => {
  return [PROGRESS_STATUS.TODO, PROGRESS_STATUS.DOING]
}

/**
 * Get all possible status values
 * @returns {Array<string>}
 */
export const getAllStatusValues = () => {
  return Object.values(PROGRESS_STATUS)
}

/**
 * Get French label for a status
 * @param {string} status
 * @returns {string}
 */
export const getStatusLabel = (status) => {
  const labels = {
    [PROGRESS_STATUS.TODO]: 'À faire',
    [PROGRESS_STATUS.DOING]: 'En cours',
    [PROGRESS_STATUS.DONE]: 'Effectué'
  }
  return labels[status] || status
}

export default PROGRESS_STATUS
